import { track } from "helpers/analytics"

export const METRICS_SELECTOR_EVENTS = {
  OPENED: "Metrics Selector Opened",
  CLOSED: "Metrics Selector Closed",
  METRIC_SELECTED: "Metrics Selector Metric Selected",
  METRIC_DESELECTED: "Metrics Selector Metric Deselected",
  SEARCH_PERFORMED: "Metrics Selector Search Performed",
  CATEGORY_EXPANDED: "Metrics Selector Category Expanded",
  CATEGORY_COLLAPSED: "Metrics Selector Category Collapsed",
  CUSTOM_VIEW_SAVED: "Metrics Selector Custom View Saved",
  CUSTOM_VIEW_UPDATED: "Metrics Selector Custom View Updated",
  CUSTOM_VIEW_DELETED: "Metrics Selector Custom View Deleted",
  PERMISSIONS_CLICKED: "Metrics Selector Permissions Clicked",
}

function getMetricsSelectorEventProperties(context) {
  if (!context) return {}

  return {
    modelId: context.modelId,
    view: context.view,
    instrumentType: context.instrument?.type,
    instrumentId: context.instrument?.id,
    selectedMode: context.selectedMode,
    hasBase: Boolean(context.base),
  }
}

export function trackMetricsSelectorOpened(context, templateMetadata = null) {
  track(METRICS_SELECTOR_EVENTS.OPENED, {
    ...getMetricsSelectorEventProperties(context),
    isEditing: Boolean(templateMetadata),
    templateId: templateMetadata?.id,
    templateName: templateMetadata?.name,
  })
}

export function trackMetricsSelectorClosed(context, templateMetadata = null) {
  track(METRICS_SELECTOR_EVENTS.CLOSED, {
    ...getMetricsSelectorEventProperties(context),
    isEditing: Boolean(templateMetadata),
    templateId: templateMetadata?.id,
    templateName: templateMetadata?.name,
  })
}

export function trackMetricSelected(context, metricId) {
  track(METRICS_SELECTOR_EVENTS.METRIC_SELECTED, {
    ...getMetricsSelectorEventProperties(context),
    metricId,
  })
}

export function trackMetricDeselected(context, metricId) {
  track(METRICS_SELECTOR_EVENTS.METRIC_DESELECTED, {
    ...getMetricsSelectorEventProperties(context),
    metricId,
  })
}

export function trackMetricsSelectorSearchPerformed(context, searchTerm) {
  track(METRICS_SELECTOR_EVENTS.SEARCH_PERFORMED, {
    ...getMetricsSelectorEventProperties(context),
    searchTerm,
    searchTermLength: searchTerm.length,
  })
}

export function trackMetricsCategoryExpanded(context, categoryId) {
  track(METRICS_SELECTOR_EVENTS.CATEGORY_EXPANDED, {
    ...getMetricsSelectorEventProperties(context),
    categoryId,
  })
}

export function trackMetricsCategoryCollapsed(context, categoryId) {
  track(METRICS_SELECTOR_EVENTS.CATEGORY_COLLAPSED, {
    ...getMetricsSelectorEventProperties(context),
    categoryId,
  })
}

export function trackCustomViewSaved(context, viewName, metricsCount) {
  track(METRICS_SELECTOR_EVENTS.CUSTOM_VIEW_SAVED, {
    ...getMetricsSelectorEventProperties(context),
    viewName,
    metricsCount,
  })
}

export function trackCustomViewUpdated(context, templateId, viewName, metricsCount) {
  track(METRICS_SELECTOR_EVENTS.CUSTOM_VIEW_UPDATED, {
    ...getMetricsSelectorEventProperties(context),
    templateId,
    viewName,
    metricsCount,
  })
}

export function trackCustomViewDeleted(context, templateId, viewName) {
  track(METRICS_SELECTOR_EVENTS.CUSTOM_VIEW_DELETED, {
    ...getMetricsSelectorEventProperties(context),
    templateId,
    viewName,
  })
}

export function trackMetricsSelectorPermissionsClicked(context, templateId, viewName) {
  track(METRICS_SELECTOR_EVENTS.PERMISSIONS_CLICKED, {
    ...getMetricsSelectorEventProperties(context),
    templateId,
    viewName,
  })
}
